export function htSignUpHandler(ev) {
  ev.preventDefault();
  const formData = new FormData(ev.target);

  /**
   * Email Validation
   * @type {RegExp}
   */
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!re.test(String(formData.get('email')).toLowerCase())) {
    const htFormEmail = document.getElementById('ht-email');
    const errorDiv = document.createElement('div');
    errorDiv.classList.add('hs-error-msgs');
    const errorSpan = document.createElement('span');
    errorSpan.classList.add('hs-error-msg');
    errorSpan.innerText = 'Valid email address required.';
    errorDiv.appendChild(errorSpan);

    htFormEmail.parentNode.insertBefore(errorDiv, htFormEmail.nextSibling);

    return;
  }

  /**
   * Get Page 1 Hubspot form and inputs
   */
  const hsForm = document.getElementById('hsForm_949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormEmail = document.getElementById('email-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormFirstName = document.getElementById('firstname-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormLastName = document.getElementById('lastname-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormWaterFowl = document.getElementById('pursuit_preferences0-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormTurkey = document.getElementById('pursuit_preferences1-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormDeer = document.getElementById('pursuit_preferences2-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormElk = document.getElementById('pursuit_preferences3-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormUpland = document.getElementById('pursuit_preferences4-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormClays = document.getElementById('pursuit_preferences5-949c98b0-32a1-4f81-b47a-3ac1c82256dd');
  const hsFormEveryDay = document.getElementById('pursuit_preferences6-949c98b0-32a1-4f81-b47a-3ac1c82256dd');

  // Get email input from page 4 Hubspot form
  const hs2FromEmail = document.getElementById('email-81610845-f4e1-4819-a626-54b6f4af0c4f');

  /**
   * Populate Page 1 Hubspot inputs
   */
  hsFormEmail.value = formData.get('email');
  hsFormFirstName.value = formData.get('firstname');
  hsFormLastName.value = formData.get('lastname');
  hsFormWaterFowl.checked = formData.get('pursuit_preferences0') !== null;
  hsFormTurkey.checked = formData.get('pursuit_preferences1') !== null;
  hsFormDeer.checked = formData.get('pursuit_preferences2') !== null;
  hsFormElk.checked = formData.get('pursuit_preferences3') !== null;
  hsFormUpland.checked = formData.get('pursuit_preferences4') !== null;
  hsFormClays.checked = formData.get('pursuit_preferences5') !== null;
  hsFormEveryDay.checked = formData.get('pursuit_preferences6') !== null;

  // Populate Page 2 Hubspot email input
  hs2FromEmail.value = formData.get('email');

  // Submit form
  hsForm.submit();

  // Progress to second page
  document.getElementById('hearingTest').classList.add('email-submitted', 'show-controls');

}
